import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Link from 'react-router/lib/Link';
import SocialIcons from '../../common/social_icons';
import ResponsiveImg from '../../common/responsive_img';
import MediaQuery from '../../common/media_query';
import ContentCaption from '../../section/content_caption';
import classNames from 'classnames';
import { getSlideLocation } from '../../../utils/slideshow';
import { open } from '../../../utils/dom';
import { sendAnalyticsEvent, sendDataLayerEvent } from '../../../utils/analytics';
import { scrollToTopDesktopAd } from '../../../utils/slideshow';
import { openerImageTypeToRatio } from '../../../utils/images';
import {
  DESKTOP_FULL_WIDTH_SLIDESHOW_CONTAINER_WIDTH_PX,
  DESKTOP_SLIDESHOW_CONTAINER_WIDTH_PX,
  NON_MOBILE_GRID_WIDTH_PX,
  EDITION_ID_DE_DE,
  EDITION_ID_FR_FR
} from '../../../constants';
import {isFunction} from 'lodash';

const FIRST_SLIDE_IDX = 1;

export default class IntroSlide extends Component {
  state = { isLoaded: false };

  shouldComponentUpdate = (nextProps, nextState) =>
    nextProps.openerImage !== this.props.openerImage
    || this.state.isLoaded !== nextState.isLoaded;

  handleClick = () => {
    const {
      handleClick,
      openerImage: { asset: { clicktracker } }
    } = this.props;
    sendAnalyticsEvent('Slideshow', 'Click', 'Begin Image');
    sendDataLayerEvent('Click', {
      actionType: 'Begin Slideshow',
      itemName: 'Slideshow',
      pageModule: 'Slideshow',
      slideshowComponent: 'Begin Image'
    });
    handleClick();
    scrollToTopDesktopAd();
    clicktracker && open(clicktracker, '_blank');
  };

  handleImgLoad = () => {
    this.setState({ isLoaded: true });
  };

  impressionTracker = () =>
    this.props.openerImage.asset.impressiontracker
    && (
      <img className="impression-tracker no-content"
        src={this.props.openerImage.asset.impressiontracker}
      />
    );

  desktopOpenerImageWidth = () =>
    this.props.isFullWidth
      ? DESKTOP_FULL_WIDTH_SLIDESHOW_CONTAINER_WIDTH_PX
      : DESKTOP_SLIDESHOW_CONTAINER_WIDTH_PX;

  openerImageElement() {
    const { isLoaded } = this.state;
    const { openerImage } = this.props;
    const { edition_data } = this.context;
    const imgProps = {
      src: openerImage.asset.src.full,
      className: classNames({ loading: !isLoaded }),
      onLoad: this.handleImgLoad
    };
    const ratio = openerImageTypeToRatio(openerImage.type);
    const desktopOpenerImageWidth = this.desktopOpenerImageWidth();
    return (
      <div className={classNames('img-container', { loading: !isLoaded })}>
        <MediaQuery breakpoint="notDesktop">
          <ResponsiveImg {...imgProps}
            alt={openerImage.alt_title}
            width={NON_MOBILE_GRID_WIDTH_PX}
            height={NON_MOBILE_GRID_WIDTH_PX / ratio}
          />
        </MediaQuery>
        <MediaQuery breakpoint="desktop">
          <ResponsiveImg {...imgProps}
            alt={openerImage.alt_title}
            width={desktopOpenerImageWidth}
            height={desktopOpenerImageWidth / ratio}
          />
        </MediaQuery>
        <div className="intro-slide-overlay">
          <div className={classNames('intro-slide-instructions', {
            'de': edition_data.id === EDITION_ID_DE_DE,
            'fr': edition_data.id === EDITION_ID_FR_FR
          })}
          />
        </div>
      </div>
    );
  }

  openerImage = () =>
    isFunction(this.props.handleClick)
      ? (
        <Link to={getSlideLocation(FIRST_SLIDE_IDX, this.context.location)}
          onClick={this.handleClick}
        >
          {this.openerImageElement()}
        </Link>
      )
      : this.openerImageElement();

  render = () => (
    <div className="intro-slide">
      <figure>
        {this.impressionTracker()}
        {this.openerImage()}
        <SocialIcons
          className="image-shares"
          icons={['pinterest', 'facebook']}
          asset_main={{ src_full: this.props.openerImage.asset.src.full }}
          {...this.props.socialIconProps}
        />
      </figure>
      <ContentCaption credit={this.props.openerImage.asset.credit} />
    </div>
  );
}

IntroSlide.propTypes = {
  handleClick: PropTypes.func,
  isFullWidth: PropTypes.bool,
  openerImage: PropTypes.shape({
    type: PropTypes.string.isRequired,
    alt_title: PropTypes.string,
    asset: PropTypes.shape({
      src: PropTypes.shape({
        full: PropTypes.string.isRequired
      }).isRequired,
      credit: PropTypes.string.isRequired,
      impressiontracker: PropTypes.string,
      clicktracker: PropTypes.string
    }).isRequired
  }).isRequired,
  socialIconProps: PropTypes.object.isRequired
};

IntroSlide.contextTypes = {
  location: PropTypes.object,
  edition_data: PropTypes.object
};
